module.exports = __webpack_public_path__ + "img/definitive-semipublic.e3b0ecf7.svg";